export const ProjectMemberApi = {
  info: '/api/v2/store/customer/project/member/info',
  growthLogList: '/api/v2/store/customer/project/member/growth/log/list',
  levelList: '/api/v2/store/customer/project/member/level/list',
  growthPriceList: '/api/v2/store/customer/project/member/growth/price/list'
}

export default (request) => {
  return {
    getVipUserInfo: (params) => request.get(ProjectMemberApi.info, { params }),
    getGrowthLogList: (params) => request.get(ProjectMemberApi.growthLogList, { params }),
    getLevelList: (params) => request.get(ProjectMemberApi.levelList, { params }),
    getGrowthPriceList: (params) => request.get(ProjectMemberApi.growthPriceList, { params })
  }
}